import { API } from "actions/api";

// One-time handoff tokens (OTTs) for arriving from another first-party app
// without a reusable session token in the URL. See S3DEV2-7560.

// Mint a handoff token for the CURRENT session. Auth is attached by the api
// middleware, so this action deliberately carries no credential of its own.
// Errors propagate so the caller can abort rather than opening a dead link.
export const mintPapyrusOtt = () => async dispatch => {
  const { ott } = await dispatch({
    type: API,
    route: "Papyrus/MintHandoffToken",
    method: "POST"
  });
  return ott;
};

// Redeem a handoff token minted by another app (today: the mobile app opening
// the order form in the device browser) for this session's JWT.
//
// publicRoute is required and correct: the caller is a freshly opened browser
// tab with no session at all — obtaining one is the entire point. The token is
// what authenticates: opaque, single-use, consumed server-side on first
// redemption, and purpose-scoped so a papyrus handoff cannot be spent here.
export const redeemPortalOtt = ott => async dispatch => {
  const { token } = await dispatch({
    type: API,
    route: "Handoff/RedeemPortalToken",
    method: "POST",
    publicRoute: true,
    body: { ott }
  });
  return token;
};
